// extracted by mini-css-extract-plugin
export default {"wrapper":"xaX0ZB","mobile":"hmT5xZ","block":"l6XzhG"};